// ==========================================
// 2. MODIFIER app-routing.module.ts
// ==========================================

import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeScreenComponent } from "./welcome/home-screen/home-screen.component";
import { AuthGuard } from "./_helpers/auth.guard";
import { NotAuthGuard } from "./_helpers/not-auth.guard";
import { ProfileGuard } from "./_guards/profile.guard"; // ⬅️ AJOUTER CETTE LIGNE

const routes: Routes = [
  {
    path: "welcome",
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: HomeScreenComponent,
        canActivate: [NotAuthGuard],
      },
      {
        path: "start",
        canActivate: [NotAuthGuard],
        loadChildren: () =>
          import("./welcome/start/start.module").then((m) => m.StartModule),
      },
      {
        path: "menu",
        canActivate: [AuthGuard],
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./welcome/home-menu/home-menu.module").then(
                (m) => m.HomeMenuModule
              ),
            // Pas de ProfileGuard ici car accessible à tous
          },
          {
            path: "password-update",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/password-update/password-update.module"
                  ).then((m) => m.PasswordUpdateModule),
                // Accessible à tous
              },
            ],
          },

          // ✅ Routes accessibles à TOUS les profils
          {
            path: "users",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/user-management/user-management.module"
                  ).then((m) => m.UserManagementModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1', 'profile_code_2']
                }
              },
            ],
          },
          {
            path: "monitoring",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/historic-management/historic-management.module"
                  ).then((m) => m.HistoricManagementModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1', 'profile_code_2']
                }
              },
            ],
          },
          {
            path: "historique-souscription",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-souscription-history/automobile-souscription-history.module"
                  ).then((m) => m.AutomobileSouscriptionHistoryModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1', 'profile_code_2']
                }
              },
            ],
          },

          // ❌ Routes réservées au SUPERADMIN UNIQUEMENT
          {
            path: "zones",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/zone-management/zone-management.module"
                  ).then((m) => m.ZoneManagementModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "pays",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/pays-management/pays-management.module"
                  ).then((m) => m.PaysManagementModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "intermediaries",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/pos-management/pos-management.module"
                  ).then((m) => m.PosManagementModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "annulation-impression",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/annulation-impression/annulation-impression.module"
                  ).then((m) => m.AnnulationImpressionModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "bancassurance-menu",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-menu/bancassurance-menu.module"
                  ).then((m) => m.BancassuranceMenuModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1','bank_admin'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          }
          ,
          {
            path: "admin-warranties",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-warranties/bancassurance-admin-warranties.module"
                  ).then((m) => m.BancassuranceAdminWarrantiesModule),
                canActivate: [ProfileGuard],
                data: {
                  allowedProfiles: ['profile_code_1']
                }
              },
            ],
          },
          {
            path: "admin-co-assureurs",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-co-assureur/bancassurance-admin-co-assureur.module"
                  ).then((m) => m.BancassuranceAdminCoAssureurModule),
                canActivate: [ProfileGuard],
                data: {
                  allowedProfiles: ['profile_code_1']
                }
              },
            ],
          },
          {
            path: "admin-parametre",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-parametre/bancassurance-admin-parametre.module"
                  ).then((m) => m.BancassuranceAdminParametreModule),
                canActivate: [ProfileGuard],
                data: {
                  allowedProfiles: ['profile_code_1']
                }
              },
            ],
          },

          // Routes bancassurance (Superadmin uniquement)
          {
            path: "admin-branches",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-branches/bancassurance-admin-branches.module"
                  ).then((m) => m.BancassuranceAdminBranchesModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1','bank_admin'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "admin-templates",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-templates/bancassurance-admin-templates.module"
                  ).then((m) => m.BancassuranceAdminTemplatesModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "admin-questionnaires",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-questionnaires/bancassurance-admin-questionnaires.module"
                  ).then((m) => m.BancassuranceAdminQuestionnairesModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "admin-banks",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-banks/bancassurance-admin-banks.module"
                  ).then((m) => m.BancassuranceAdminBanksModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "admin-products",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-products/bancassurance-admin-products.module"
                  ).then((m) => m.BancassuranceAdminProductsModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "admin-bancassurance-users",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-user-management/bancassurance-user-management.module"
                  ).then((m) => m.BancassuranceUserManagementModule),
                canActivate: [ProfileGuard], // ⬅️ AJOUTER
                data: {
                  allowedProfiles: ['profile_code_1','bank_admin'] // ⬅️ Superadmin uniquement
                }
              },
            ],
          },
          {
            path: "dashboard-orass",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/dashboard-orass/dashboard-orass.module"
                  ).then((m) => m.DashboardOrassModule),
                canActivate: [ProfileGuard],
                data: {
                  allowedProfiles: ['profile_code_1']
                }
              },
            ],
          },
        ],
      },
      {
        path: "thankyou",
        loadChildren: () =>
          import("./welcome/exit-screen/exit-screen.module").then(
            (m) => m.ExitScreenModule
          ),
      },
      {
        path: "intro",
        loadChildren: () =>
          import("./welcome/intro-screen/intro-screen.module").then(
            (m) => m.IntroScreenModule
          ),
      },
    ],
  },
  { path: "", redirectTo: "/welcome/home", pathMatch: "full" },
  {
    path: "**",
    redirectTo: "/welcome/home",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
